import { useEffect } from "react";
import { useDisconnect, useActiveWallet } from "thirdweb/react";

export default function SignoutPage() {
    const { disconnect } = useDisconnect();
    const wallet = useActiveWallet();

    useEffect(() => {
        walletLogout();
    }, []);

    const walletLogout = async () => {
        try {
            if (wallet) {
                await disconnect();
            }
        } catch (error) {
            console.error("Error in disconnecting wallet", error);
        }
        localStorage.clear();
        sessionStorage.clear();
        // navigate("/signin"); // go to signin page
        // await disconnectWallet();
        window.location = "/signin";
        // navigate("/signin");
    };

    return null;
}
